import LineInput from 'components/inputs/LineInput'
import NumberInput from 'components/inputs/NumberInput'
import React, { useCallback } from 'react'
import IInput from './IInput'
import './GeneratedFrom.css'
import PhoneInput from 'components/inputs/PhoneInput'
import DateInput from 'components/inputs/DateInput'
import MultiLineInput from 'components/inputs/MultiLineInput'
import TimeInput from 'components/inputs/TimeInput'
import EmailInput from 'components/inputs/EmailInput'

const toInt = (value?: number | string): number | undefined => {
  if (value) {
    return typeof value === 'number' ? value : parseInt(value)
  } else {
    return undefined
  }
}

interface IFormInputSwitchProps {
  input: IInput
  onChange?: (id: string, value: string | number | null) => void
  onEntered?: (id: string, value: string | number | null) => void
}

const FormInputSwitch: React.FC<IFormInputSwitchProps> = ({
  input,
  onChange,
  onEntered,
}) => {
  const handleChange = useCallback(
    (value: string | number | null) => {
      if (onChange) onChange(input.id, value)
    },
    [input, onChange]
  )

  const handleEntered = useCallback(
    (value: string | number | null) => {
      if (onEntered) onEntered(input.id, value)
    },
    [input, onEntered]
  )

  return (
    <>
      {input.type === 'str' ? (
        <LineInput
          defaultValue={input.defaultValue?.toString()}
          placeholder={input.placeholder || input.title}
          onChange={handleChange}
          onEntered={handleEntered}
          isRequired={input.required}
          {...input.otherProps}
        />
      ) : input.type === 'int' ? (
        <NumberInput
          defaultValue={toInt(input.defaultValue)}
          placeholder={input.placeholder || input.title}
          onChange={handleChange}
          onEntered={handleEntered}
          {...input.otherProps}
        />
      ) : input.type === 'phone' ? (
        <PhoneInput
          defaultValue={input.defaultValue?.toString()}
          onChange={handleChange}
          onEntered={handleEntered}
          isRequired={input.required}
          {...input.otherProps}
        />
      ) : input.type === 'multiline' ? (
        <MultiLineInput
          defaultValue={input.defaultValue?.toString()}
          placeholder={input.placeholder || input.title}
          onChange={handleChange}
          onEntered={handleEntered}
          {...input.otherProps}
        />
      ) : input.type === 'date' ? (
        <DateInput
          defaultValue={input.defaultValue?.toString()}
          onChange={handleChange}
          onEntered={handleEntered}
          {...input.otherProps}
        />
      ) : input.type === 'time' ? (
        <TimeInput
          defaultValue={input.defaultValue?.toString()}
          onChange={handleChange}
          onEntered={handleEntered}
          {...input.otherProps}
        />
      ) : input.type === 'email' ? (
        <EmailInput
          defaultValue={input.defaultValue?.toString()}
          placeholder={input.placeholder || input.title}
          onChange={handleChange}
          onEntered={handleEntered}
          isRequired={input.required}
          {...input.otherProps}
        />
      ) : input.type === 'component' && input.component ? (
        <>
          {input.component(
            handleChange,
            handleEntered,
            input.defaultValue,
            input.required,
            input.otherProps
          )}
        </>
      ) : (
        <LineInput
          defaultValue={input.defaultValue?.toString()}
          placeholder={input.placeholder || input.title}
          onChange={handleChange}
          onEntered={handleEntered}
          isRequired={input.required}
          {...input.otherProps}
        />
      )}
    </>
  )
}

export default FormInputSwitch
export type { IFormInputSwitchProps }
